// Main exports for the npm package
export { default as BatchEditor } from '../BatchEditor';
export { default as TaskCard } from '../TaskCard';

// Export CSS (will be bundled)
import '../BatchEditor.css';
import '../TaskCard.css';

// Export any utility functions or hooks if needed
export const BatchEditorUtils = {
  // Utility function to create a new batch
  createBatch: (id, name, quantity, partType, partIcon = '🔧') => ({
    id,
    name,
    quantity,
    partType,
    partIcon,
    processes: []
  }),

  // Utility function to create a new process
  createProcess: (id, name, type, color) => ({
    id,
    name,
    type,
    color
  }),

  // Utility function to create a new recipe
  createRecipe: (id, name, color, processes) => ({
    id,
    name,
    type: 'recipe',
    color,
    processes
  }),

  // Utility function to validate batch data
  validateBatch: (batch) => {
    const required = ['id', 'name', 'quantity', 'partType', 'processes'];
    return required.every(field => batch.hasOwnProperty(field));
  },

  // Utility function to calculate total process time
  calculateTotalTime: (processes) => {
    return processes.reduce((total, process) => {
      return total + (process.duration || 0);
    }, 0);
  }
};

// Default export
export { default } from '../BatchEditor'; 